import { render, staticRenderFns } from "./receive-payment.vue?vue&type=template&id=716403dc"
import script from "./receive-payment.vue?vue&type=script&lang=js"
export * from "./receive-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports